import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { type Doc } from "../../DeliveryOverview/DeliveryOverview.types";

function getCreatedColumn(): MRT_ColumnDef<Doc> {
  return {
    header: "Erstellung",
    accessorKey: "created",
    accessorFn: (row) =>
      (row.documentType === "invoice" || row.documentType === "reversed") &&
      row.invoiceData
        ? backendDateOrDateTimeToLuxonDateTime(
            row.invoiceData.created
          ).toJSDate()
        : undefined,
    size: 140,
    sortingFn: "datetime",
    sortUndefined: "last",
    filterVariant: "date-range",
    Cell: ({ row }) =>
      row.original.documentType === "invoice" ||
      row.original.documentType === "reversed"
        ? row.original.invoiceData?.created.split(" ")[0]
        : ""
  };
}

export { getCreatedColumn };
